<template>
  <span @click="abrirTJ">
    {{ propMensalista ? propSelo.selo.num_selo : propSelo ?
      propSelo.selo.num_selo.substring(0,6) + '...' : '---' }}
  </span>
</template>

<script>
  export default ({
    name: 'TableSelo',
    props: {
      propSelo: {type: Object, default: null},
      propMensalista: {type: Boolean, default: null}
    },
    data () {
      return {

      }
    },
    methods: {
      abrirTJ () {
        const numSelo = this.propSelo.selo.num_selo ? this.propSelo.selo.num_selo : null
        if (!numSelo) return
        window.open(`https://selodigital-tjsp.msappproxy.net/hselodigitalconsulta?r=${numSelo}`)
      }
    }
  })

</script>
